import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getMinMonthlyRepaymentAmount } from '@helpers/RepaymentSchedule/getMinMonthlyRepaymentAmount';
import { getTotalRepaymentAmount } from '@helpers/RepaymentSchedule/getTotalRepaymentAmount';

export const useLoanSummaryData = ({
    selectedOffer,
    drawdownAmount
}: {
    selectedOffer: TFormalOffer | undefined;
    drawdownAmount: number;
}) => {
    const { data } = useDrawdownRepaymentSchedule({
        offerId: selectedOffer?.offer_id ?? '',
        drawdownAmount,
        enabled: Boolean(selectedOffer),
        keepPreviousData: true
    });

    return {
        monthlyRepayment: data ? getMinMonthlyRepaymentAmount(data) : null,
        fullTermRepayment: data ? getTotalRepaymentAmount(data) : null
    };
};
